import { ReactElement } from 'react';

import { HistoricalVisit } from '@dreryk/egabinet-visit-frontend-api';

import { Translate } from '@dreryk/react-common';
import { SidePanelListNoItemsMessage } from '@dreryk/react-components';

import { historicalVisitTranslationKeys } from '../../translations';

import { HistoricalVisitElectronicReferral } from './HistoricalVisitElectronicReferral';
import { StyledHistoricalVisitElectronicDocumentItemWrapper } from './HistoricalVisitElectronicDocumentItem.styled';

type HistoricalVisitElectronicDocumentsProps = {
   historicalVisit: HistoricalVisit;
};

export const HistoricalVisitElectronicDocuments = (props: HistoricalVisitElectronicDocumentsProps): ReactElement => {
   const { historicalVisit } = props;
   const electronicDocumentsCount = historicalVisit.electronicReferrals.length + historicalVisit.dischareSummariesCount;

   if (electronicDocumentsCount === 0) {
      return <SidePanelListNoItemsMessage message={historicalVisitTranslationKeys.noElectronicDocumentsIssued} />;
   }

   return (
      <>
         {historicalVisit.electronicReferrals.map((electronicReferral) => (
            <HistoricalVisitElectronicReferral key={electronicReferral.code} {...electronicReferral} />
         ))}
         {[...Array(historicalVisit.dischareSummariesCount)].map((_, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <StyledHistoricalVisitElectronicDocumentItemWrapper key={idx}>
               <p>
                  <Translate>{historicalVisitTranslationKeys.dischargeSummary}</Translate>
               </p>
            </StyledHistoricalVisitElectronicDocumentItemWrapper>
         ))}
      </>
   );
};
